/* eslint-disable max-len */
import React from "react";
import styles from "./home.module.scss";
import {
  calendarIcon,
  ethIcon,
  globeIcon,
  lightbulbIcon,
  unlockIcon,
  separator01,
  separator02,
  separator03,
  separator04,
} from "../../utils/svg";
import { useMenu } from "../../components/menu/useMenu";
import { TabKeys } from "../../data/tabs";
import { TechCard } from "../../components/tech-card/TechCard.component";
// import { Testimonials } from "../../components/testimonials/Testimonials.component";
import { ScrollReveal } from "../../components/scroll-reveal/ScrollReveal.component";
import { GradientIcon } from "../../components/gradient-icon/GradientIcon.component";
import { SeoComponent } from "../../components/seo/Seo.component";

export const Home: React.FC = () => {
  return (
    <div className={styles["home"]}>
      <SeoComponent
        title="Volumetric Labs"
        description="Architecting the future with Blockchain, AI, and Cloud solutions. We build scalable, secure, and innovative software for the modern web."
      />
      <ScrollReveal animation="fade-up" delay={100}>
        <section className={styles["hero-section"]}>
          <div className={styles["hero-content"]}>
            <div className={styles["hero-header"]}>
              <div className={styles["icon-wrapper"]}>
                <GradientIcon path={lightbulbIcon} viewBox="0 0 384 512" />
              </div>
              <h1 className={styles["hero-title"]}>Architecting the Future</h1>
            </div>
            <Intro />
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal animation="fade-up" delay={200}>
        <section className={styles["mission-section"]}>
          <div className={styles["mission-content"]}>
            <div className={styles["mission-header"]}>
              <div className={styles["icon-wrapper"]}>
                <GradientIcon path={globeIcon} viewBox="0 0 496 512" />
              </div>
              <h2>Our Mission</h2>
            </div>
            <Mission />
          </div>
        </section>
      </ScrollReveal>

      <ScrollReveal animation="fade-up" delay={300}>
        <section className={styles["hero-section"]}>
          <div className={styles["hero-content"]}>
            <div className={styles["hero-header"]}>
              <div className={styles["icon-wrapper"]}>
                <GradientIcon path={ethIcon} viewBox="0 0 256 417" />
              </div>
              <h2 className={styles["hero-title"]}>Expertise</h2>
            </div>
            <Expertise />
          </div>
        </section>
      </ScrollReveal>

      {/* <ScrollReveal animation="scale-up" delay={400}>
        <Testimonials />
      </ScrollReveal> */}
    </div>
  );
};

const Intro: React.FC = () => {
  const { onTabSelected } = useMenu();
  return (
    <div className={styles["card-content"]}>
      <div className={styles["text-content"]}>
        <p>
          Volumetric Labs is a premier technology consultancy dedicated to
          bridging the gap between traditional web technologies and the emerging
          frontiers of AI and Blockchain. We provide expert guidance and
          development services to startups and established enterprises alike.
        </p>
        <div className={styles["separator-container"]}>
          <svg viewBox="0 0 384 24" className={styles["separator"]}>
            <path d={separator02} />
          </svg>
        </div>
        <p>
          Founded by a team of industry veterans, we bring decades of combined
          experience in software engineering, distributed systems, and product
          strategy. We don't just build software; we build sustainable
          businesses powered by technology.
        </p>
      </div>
      <div className={styles["footer"]}>
        <div className={styles["tags"]}>
          <span className={styles["tag"]}>Web3</span>
          <span className={styles["tag"]}>AI</span>
          <span className={styles["tag"]}>Strategy</span>
        </div>
        <span
          className={styles["learn-more"]}
          onClick={() => onTabSelected(TabKeys.Contact)}>
          Get in Touch
        </span>
      </div>
    </div>
  );
};

const Mission: React.FC = () => {
  const { onTabSelected } = useMenu();
  return (
    <div className={styles["card-content"]}>
      <div className={styles["text-content"]}>
        <p>
          Our mission is to empower businesses with cutting-edge technology
          solutions. Whether it's navigating the complexities of Web3,
          implementing robust security measures, or leveraging the power of
          Artificial Intelligence, Volumetric Labs is your partner in
          innovation.
        </p>
        <div className={styles["separator-container"]}>
          <svg viewBox="0 0 384 24" className={styles["separator"]}>
            <path d={separator03} />
          </svg>
        </div>
        <p>
          We believe in a future where technology serves humanity, creating more
          transparent, efficient, and equitable systems. Every line of code we
          write is a step towards that vision, ensuring that our clients are
          always at the forefront of the digital revolution.
        </p>
      </div>
      <div className={styles["footer"]}>
        <div className={styles["tags"]}>
          <span className={styles["tag"]}>Innovation</span>
          <span className={styles["tag"]}>Security</span>
          <span className={styles["tag"]}>Future</span>
        </div>
        <span
          className={styles["learn-more"]}
          onClick={() => onTabSelected(TabKeys.About)}>
          About
        </span>
      </div>
    </div>
  );
};

const Expertise: React.FC = () => {
  const { onTabSelected } = useMenu();
  return (
    <div className={styles["card-content"]}>
      <div className={styles["text-content"]}>
        <p>
          We specialize in a wide range of services including full-stack
          development, startup advisory, security audits, and strategic
          consulting in AI and Blockchain. Our team brings deep technical
          expertise and a forward-thinking approach to every project.
        </p>
        <div className={styles["separator-container"]}>
          <svg viewBox="0 0 384 24" className={styles["separator"]}>
            <path d={separator04} />
          </svg>
        </div>
        <p>
          From smart contract development to large-scale distributed systems, we
          have the know-how to tackle the most challenging technical problems.
          We pride ourselves on delivering high-quality, maintainable code that
          scales with your business.
        </p>
      </div>
      <div className={styles["footer"]}>
        <div className={styles["tags"]}>
          <span className={styles["tag"]}>Full Stack</span>
          <span className={styles["tag"]}>Advisory</span>
          <span className={styles["tag"]}>Architecture</span>
        </div>
        <span
          className={styles["learn-more"]}
          onClick={() => onTabSelected(TabKeys.Services)}>
          Services
        </span>
      </div>
    </div>
  );
};
